import React from 'react';
import { ShieldCheck } from '../../../../icons';
import { GRAD_TEXT } from '../shared';

const colLabel: React.CSSProperties = {
  fontSize: 12, fontWeight: 500, color: '#A3A3A3',
  textTransform: 'uppercase', letterSpacing: 0.4,
};

const DIVIDER: React.CSSProperties = { height: 1, background: '#E5E5E5' };

export function SafetyChecksCard({
  topics,
  themes,
  audienceType,
  audienceSentiment,
  brandCollabSignals,
  aiSummary,
  channelStats,
  checkPill,
}: {
  topics: string[];
  themes: string[];
  audienceType?: string;
  audienceSentiment?: string;
  brandCollabSignals?: string;
  aiSummary?: string;
  channelStats?: { scanned: number; last12Months: number; analyzed: number; isInstagram: boolean };
  checkPill: { label: string; bg: string; color: string };
}) {
  return (
    <div style={{ borderRadius: 16, overflow: 'hidden', border: '1px solid #E5E5E5' }}>
      {/* ── Header strip (#FAFAFA) — Figma 1741:55607 "hdr" ── */}
      <div style={{
        background: '#FAFAFA', borderBottom: '1px solid #E5E5E5',
        padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: 4,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <ShieldCheck size={28} color="#343330" />
            <span style={{ fontSize: 20, fontWeight: 500, color: '#171717' }}>Safety Checks</span>
          </span>
          <span style={{
            background: checkPill.bg, color: checkPill.color,
            fontSize: 12, fontWeight: 600, padding: '2px 12px', borderRadius: 999,
            textTransform: 'capitalize',
          }}>
            {checkPill.label}
          </span>
        </div>
        {channelStats && (
          <div style={{ fontSize: 16, fontWeight: 400, color: '#404040' }}>
            Scanned {channelStats.scanned} {channelStats.isInstagram ? 'posts' : 'videos'}
            {' · '}Last 12 months: {channelStats.last12Months}
            {' · '}Deep-analyzed {channelStats.analyzed}
          </div>
        )}
      </div>

      {/* ── Body card (#FFFFFF) ── */}
      <div style={{ background: '#fff' }}>
        <div style={{ display: 'flex', alignItems: 'stretch' }}>
          <div style={{ flex: 1, minWidth: 0, padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={colLabel}>Primary Topics</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {topics.map((t) => (
                <span key={t} style={{ background: '#EDEAFC', color: '#4F39C7', fontSize: 14, fontWeight: 500, padding: '5px 10px', borderRadius: 999 }}>
                  {t}
                </span>
              ))}
            </div>
          </div>
          <div style={{ width: 1, background: '#E5E5E5', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0, padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={colLabel}>Content Themes</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {themes.map((t) => (
                <span key={t} style={{ background: '#F0FDF9', color: '#0B7A57', border: '1px solid #A7E3C4', fontSize: 14, fontWeight: 500, padding: '5px 10px', borderRadius: 999 }}>
                  {t}
                </span>
              ))}
            </div>
          </div>
          <div style={{ width: 1, background: '#E5E5E5', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0, padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div style={colLabel}>Audience</div>
            {audienceType && (
              <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: '#171717', lineHeight: 1.5 }}>
                {String(audienceType)}
              </p>
            )}
            {audienceSentiment && (
              <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: '#0B7A57', lineHeight: 1.5 }}>
                {String(audienceSentiment)}
              </p>
            )}
          </div>
        </div>

        {brandCollabSignals && (
          <>
            <div style={DIVIDER} />
            <div style={{ padding: '20px 28px', display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={colLabel}>Brand Collab Signals</div>
              <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: '#404040', lineHeight: 1.5 }}>
                {String(brandCollabSignals)}
              </p>
            </div>
          </>
        )}

        {aiSummary && (
          <>
            <div style={DIVIDER} />
            <div style={{ padding: '20px 28px', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <span style={{ ...GRAD_TEXT, fontSize: 24, fontWeight: 700, lineHeight: 1.2, flexShrink: 0 }}>✦</span>
              <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: '#404040', lineHeight: 1.5 }}>
                {String(aiSummary)}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
